module.exports = __webpack_public_path__ + "img/LAOPU-icon.b960fdf9.png";